import { css } from "@emotion/react";
import { Theme } from "@mui/material";

export const HEADER_HEIGHT = 64;

export const headerWithContextStyles = {
  headerStyles: (theme: Theme) =>
    css({
      background: theme.palette.background.paper,
      color: theme.palette.text.primary,
      width: "100%",
      position: "sticky",
      top: 0,
      display: "flex",
      flexDirection: "column",
      zIndex: theme.zIndex.appBar,
    }),
  headerContent: css({
    height: HEADER_HEIGHT,
    display: "flex",
    padding: "0 12px",
    justifyContent: "space-around",
    alignItems: "center",
  }),
  leftContainer: css({
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
  }),
  logo: css({
    height: "auto",
    width: "88px !important",
  }),
  logoMargin: css({
    marginLeft: 8,
    marginRight: 16,
  }),
  logoButton: css({
    display: "flex",
  }),
  rightContainer: css({
    "--gap": 8,
    display: "flex",
    alignItems: "center",
    gap: "var(--gap)",
    // provides proper spacing between this flex group
    // and the content to its left (sometimes the search icon)
    marginLeft: "var(--gap)",
  }),
  searchRAContainer: (theme: Theme) =>
    css({
      display: "flex",
      margin: "0 auto",
      width: "100%",

      [theme.breakpoints.up("lg")]: {
        maxWidth: "640px",
      },
    }),
};
